<template>
  <div>
    <preloader-item v-if="loading"></preloader-item>
    <ul class="hub_list">
      <li 
      class="hub_list__item"
      @click="goToMap"
      >
      <svg
   width="13.935533mm"
   height="15.650759mm"
   viewBox="0 0 13.935533 15.650759"
   >
  <g
     inkscape:label="Слой 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-18.129919,-48.384053)">
    <g
       id="g38"
       transform="translate(-17.337373,46.500024)"
       inkscape:groupmode="layer">
      <g
         id="g1"
         transform="matrix(0.08329442,0,0,0.08478031,32.513067,1.7242985)">
        <path
           style="fill:#5ad792;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 183.23075,96.361789 13.55044,13.838691 -17.42631,-8.02607 z"
           id="path7" />
        <path
           style="fill:#cccfcd;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:0.4, 0.4;stroke-dashoffset:0;stroke-opacity:1"
           d="m 134.21109,43.158005 27.23581,-17.704529 40.88449,-7.936897 0.20133,73.548309 -5.09592,6.897127 -14.99746,-2.144993 -7.74381,12.622428 -0.98266,20.60489 21.89077,8.08351 -17.94503,31.5736 -6.76629,17.58766 -25.8324,-0.13582 -1.92196,-5.39122 V 168.8594 l -5.55803,-0.74169 11.71688,-23.88855 -31.47248,-12.17962 -50.261024,-44.673007 4.89563,-18.051277 14.915975,5.192102 4.851623,-14.562413 12.982406,-0.17944 24.85803,13.383238 z"
           id="path5"
           sodipodi:nodetypes="cccccccccccccccccccccccc" />
        <g
           id="g29">
          <path
             style="fill:#5ad792;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 118.23379,132.01933 30.59925,12.10238 -11.09914,23.68555 5.65294,0.93298 -0.93941,10.89495 -5.7426,2.59424 0.41895,3.66224 -31.12423,-0.14342 z"
             id="path8" />
          <path
             style="fill:#5ad792;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 133.82797,43.024692 -3.89052,-2.517815 -19.53842,11.793789 -40.585255,4.980281 -32.390095,32.531827 -0.97146,28.846926 13.048403,11.83984 7.72642,7.66175 c 0,0 3.912463,9.16929 4.429871,6.59397 0.517409,-2.57532 3.75638,-6.59752 3.75638,-8.31661 0,-1.71908 0,-9.28605 0,-9.28605 l 2.344549,-40.049379 4.688409,-18.172892 15.350321,5.405509 4.798975,-14.675686 13.144842,-0.152205 23.95887,12.701781 z"
             id="path6" />
          <g
             id="g4"
             style="stroke:#000000;stroke-width:0.8;stroke-dasharray:4.8, 0.8;stroke-dashoffset:0;stroke-opacity:1">
            <path
               style="fill:none;stroke:#000000;stroke-width:0.8;stroke-dasharray:4.8, 0.8;stroke-dashoffset:0;stroke-opacity:1"
               d="m 75.776724,2.0965185 11.619936,23.1553125 43.74667,48.266449 71.07059,40.7795"
               id="path1" />
            <path
               style="fill:none;stroke:#000000;stroke-width:0.8;stroke-dasharray:4.8, 0.8;stroke-dashoffset:0;stroke-opacity:1"
               d="m 191.20047,29.595214 -12.84116,18.808287 -7.11115,15.48661 6.16555,13.716765 3.6846,14.438516 -0.22437,10.167008"
               id="path2" />
            <path
               style="fill:none;stroke:#000000;stroke-width:0.8;stroke-dasharray:4.8, 0.8;stroke-dashoffset:0;stroke-opacity:1"
               d="m 189.69239,108.03855 -11.95558,6.12157 -23.78707,67.60538 -1.02925,3.64572"
               id="path3" />
            <path
               style="fill:none;stroke:#000000;stroke-width:0.8;stroke-dasharray:4.8, 0.8;stroke-dashoffset:0;stroke-opacity:1"
               d="m 199.34452,113.24118 3.0592,7.18887"
               id="path4" />
          </g>
        </g>
        <g
           id="g28">
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 95.005503,64.215306 2.333114,1.329134 -1.467324,2.415947 -1.638151,-0.6463 z"
             id="path9" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 105.73214,69.907665 3.46079,1.600981 -2.60714,4.933664 -2.8892,-1.963473 0.46784,-1.464125 -0.65294,-0.738349 0.63405,-1.976824 1.2836,0.968952 z"
             id="path10" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 113.247,85.871221 6.03887,2.520749 -1.95404,3.598942 -5.12762,-2.846943 z"
             id="path11" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 126.66471,95.381118 3.1776,1.8179 -1.57916,3.014072 -2.8503,-1.948453 z"
             id="path12" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 162.86258,121.62487 4.61684,2.01251 -1.11017,2.56638 -4.71868,-2.2 z"
             id="path13" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 155.92637,144.15849 3.53357,1.69361 -1.42104,2.58295 -3.30535,-1.81402 z"
             id="path14" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 169.16679,141.69206 3.02005,0.85527 -0.79473,2.50122 -2.61605,-1.31809 z"
             id="path15" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 168.5943,150.51886 3.11523,1.81872 -1.14529,2.25854 -2.94558,-1.84772 z"
             id="path16" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 161.29571,163.6627 5.16484,2.16232 -1.1788,2.50827 -4.63802,-1.94725 z"
             id="path17" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 147.54711,176.45221 3.62433,1.4657 -1.01068,1.83527 -3.27206,-1.00589 z"
             id="path18" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 159.03802,174.3462 5.34793,1.59945 -0.63457,2.57692 -5.79837,-1.56088 z"
             id="path19" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 192.93739,44.906681 2.97449,2.31753 -2.35678,3.821086 -2.74443,-2.377755 z"
             id="path20" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 173.83955,39.392534 4.55102,1.317268 -2.62944,6.711008 -3.5752,-1.59475 z"
             id="path21" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 182.93107,29.710155 3.90228,1.988851 -2.06625,3.254127 -2.97779,-2.149674 z"
             id="path22" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 164.81466,65.080334 3.26163,1.590318 -2.29714,4.394515 -1.84568,-0.947992 0.71261,-2.000972 -1.07373,-0.782965 z"
             id="path23" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 145.54034,41.513812 3.29057,3.12814 -2.76291,3.548256 -2.6596,-2.370463 c 0,0 2.41507,-1.37803 1.58939,-1.557748 -0.82567,-0.179721 -1.5697,-0.792448 -1.5697,-0.792448 z"
             id="path24" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 197.2436,68.863495 2.99998,1.946121 -1.81048,2.009516 -2.8213,-1.91208 z"
             id="path25" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 196.5073,79.445066 2.16058,1.047514 -1.8502,2.998349 -2.29105,-0.89462 z"
             id="path26" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 188.9917,23.974143 2.2943,1.066737 -0.93645,1.965977 -2.19458,-1.280119 z"
             id="path27" />
          <path
             style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:0.4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
             d="m 193.70858,38.106604 4.81882,3.431201 2.75181,-5.333611 -5.60542,-3.311599 z"
             id="path28" />
        </g>
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 63.232603,185.50259 c 0,0 -1.680588,-1.73252 0.731118,-3.93252 2.411704,-2.2 1.822339,-0.6425 3.503615,-4.69474 1.681277,-4.05224 3.785682,-5.42453 5.76657,-7.58576 1.980891,-2.16123 2.826126,-5.46495 3.032017,-8.39791 0.205888,-2.93296 0.313142,-3.05612 2.482635,-5.96717 2.169496,-2.91106 4.261549,-4.62934 5.343263,-6.98542 1.081717,-2.35608 1.606302,-5.99425 3.223975,-7.46124 1.617675,-1.46699 3.662455,-6.76456 3.662455,-6.76456 0,0 2.576274,-2.88468 2.576274,-5.99974 0,-3.11505 -1.204566,-6.06116 0.340445,-7.74683 1.545008,-1.68568 4.334769,-5.11788 4.334769,-5.11788"
           id="path29" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 134.46396,42.006512 c 1.7726,-6.003669 0.764,-4.756931 3.35355,-8.104209 2.58956,-3.347278 3.64564,-2.038993 3.28845,-6.624391 -0.3572,-4.585399 -2.25711,-2.51244 0.63492,-6.154067 2.89204,-3.641627 3.37586,-2.584915 5.94567,-6.963948 2.56981,-4.3790318 1.50362,-3.020962 4.6682,-6.1581089 3.16457,-3.1371471 3.3863,-4.9045283 3.3863,-4.9045283"
           id="path30" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 94.720856,185.53023 c 3.024174,-4.92207 3.267205,-5.42648 5.032409,-8.93881 1.765205,-3.51232 3.939255,-8.50474 6.115875,-12.61532 2.17663,-4.11057 0.46079,-4.75265 2.53378,-10.68088 2.07299,-5.92823 3.07471,-10.11525 4.32555,-11.77233 1.25084,-1.65709 6.27678,-6.07234 6.27678,-6.07234 l 1.05897,-2.7188"
           id="path31" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 169.46998,24.019926 c 0,0 0.45241,-2.758592 2.56948,-5.643821 2.11707,-2.885229 1.42198,-2.413793 2.8076,-5.921209 1.38561,-3.5074154 2.33144,-3.1584623 3.08657,-6.1220654 0.75513,-2.9636035 0.46318,-4.2162963 0.46318,-4.2162963"
           id="path32" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 80.170096,99.438366 c 0,0 -1.499823,-1.148448 -3.361307,5.131694 -1.861484,6.28013 2.578585,2.61232 -2.224455,6.5751 -4.803039,3.96278 -6.568397,5.93463 -7.214409,7.45498 -0.646012,1.52035 -1.907181,3.07858 -3.788614,5.96415 -1.881434,2.88557 -3.866809,4.07892 -6.032638,8.80143 -2.165831,4.72251 -2.898592,6.9488 -6.371174,10.13346 -3.472582,3.18465 -4.246309,2.73262 -7.207147,6.40905 -2.960838,3.67643 -5.037897,4.90832 -5.670489,7.52406 -0.632595,2.61575 -2.326111,4.83201 -2.326111,4.83201"
           id="path33" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 101.15337,59.58311 c 2.30907,-3.925501 0.75791,-2.827014 3.60653,-5.441942 2.84863,-2.614927 2.84599,-2.201727 3.91391,-6.483037 1.06792,-4.281308 3.31794,-7.042423 4.86078,-10.084311 1.54283,-3.041888 3.08071,-4.062479 4.16124,-8.084873 1.08054,-4.022391 2.3998,-7.552044 1.77867,-9.959861 -0.62113,-2.407818 -0.0255,-6.07216 0.39052,-9.5304693 0.41604,-3.4583091 -0.89407,-7.6354737 -0.89407,-7.6354737"
           id="path34" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 35.699374,97.364086 c 0,0 9.012359,-5.823596 11.59401,-8.630039 2.581648,-2.806443 6.380747,-11.076546 8.625395,-14.928524 2.244649,-3.851982 10.23203,-9.837992 12.209031,-13.462016 1.977004,-3.624022 2.997116,-6.446681 6.913864,-11.397906 3.916749,-4.951222 5.789097,-3.610203 7.97292,-11.074754 2.183823,-7.464552 4.755721,-11.72088 6.922929,-16.573992 2.167207,-4.853111 5.280861,-7.606127 6.302639,-10.7655 1.021779,-3.1593734 1.021779,-8.4429782 1.021779,-8.4429782"
           id="path35" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 35.486088,41.271107 c 0,0 3.459388,-1.405609 7.377957,-6.807131 3.918571,-5.401521 5.622639,-6.022877 11.659322,-10.770333 6.036683,-4.747457 7.318399,-4.341711 10.050954,-9.535989 2.732556,-5.1942785 4.698606,-12.2602041 4.698606,-12.2602041"
           id="path36" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 198.93152,97.435952 c 0,0 -1.7529,-0.46445 -1.39097,5.894658 0.36192,6.35911 -2.63777,7.601 -3.00174,12.81059 -0.36397,5.2096 -2.88079,10.52412 -2.52127,13.38061 0.35953,2.8565 0.0355,6.66028 0.0355,6.66028"
           id="path37" />
        <path
           style="fill:none;fill-opacity:1;stroke:#6a3c00;stroke-width:0.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 190.23965,147.8383 c 0,0 -1.09195,6.31475 -0.26776,10.07619 0.82421,3.76145 3.17411,0.26183 -0.32664,6.38235 -3.50075,6.12052 -4.81473,9.39266 -4.81473,11.11706 0,1.72439 0,5.36052 0,5.36052 l 0.69889,4.52104"
           id="path38" />
      </g>
    </g>
  </g>
      </svg>
      <p class="hub_menu_p">ГИС</p>
      </li>
      <li 
      class="hub_list__item"
      v-if="state != 4"
      @click="goToTracker"
      >
        <p>Трекер</p>
      </li>
    </ul>
  </div>
</template>
<script>
import router from '@/router';
import PreloaderItem from '././preloader.vue'
import {getState} from '@/hub/auth'
export default {
  name: 'HubPage',
  components: {
    PreloaderItem,
  },
  props: {
    msg: String
  },
  data(){
    return{
      email: null,
      token: null,
      state: null,
      loading: true,
    };
  },
  methods: {
    goToMap(){
      router.push({name: 'map'})
    },
    goToTracker(){
      router.push({name: 'tracker'})
    }
  },
  async created(){
    this.token = localStorage.getItem('ArgoToken')
    if(this.token){
      this.email = localStorage.getItem('ArgoUserEmail')
      this.state = await getState(this.email, this.token)
      if(!this.state){
        this.loading = false
        router.push({name: 'login'})
      }
      this.loading=false
    }
    else{
      this.loading = false
      router.push({name: 'login'})
    }
    
  }
}
</script>